import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Alert, Table, Modal } from 'react-bootstrap';
import axios from 'axios';

const ApartmentByCity = () => {
  const [title, setTitle] = useState('');
  const [apartmentList, setApartmentList] = useState([]); // Initialize with an empty array
  const [editId, setEditId] = useState(null); // Track the apartment ID being edited
  const [showAlert, setShowAlert] = useState({ visible: false, type: '', message: '' });
  const [searchTerm, setSearchTerm] = useState(''); // Search filter for titles
  const [showModal, setShowModal] = useState(false); // Control modal visibility

  // Fetch apartments by city on component mount
  useEffect(() => {
    fetchApartmentList();
  }, []);

  const fetchApartmentList = async () => {
    try {
      const response = await axios.get('https://api.biznetusa.com/api/get-searchbyapartment');
      setApartmentList(response.data.apartment_by_city || []); // Access the correct key and ensure it defaults to an empty array
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    setTitle(e.target.value);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataToSubmit = { title };

    try {
      // Add a new apartment title
      await axios.post('https://api.biznetusa.com/api/store-searchbyapartment', formDataToSubmit);
      setShowAlert({ visible: true, type: 'success', message: 'Apartment title added successfully' });
      setTitle('');
      fetchApartmentList(); // Refresh apartment list after submission
    } catch (error) {
      console.error(error);
      setShowAlert({ visible: true, type: 'danger', message: 'Failed to submit data' });
    }
  };

  const handleEdit = (apartment) => {
    setTitle(apartment.title);
    setEditId(apartment.id); // Track the ID for editing the title
    setShowModal(true); // Show the modal for editing
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const formDataToSubmit = { title };

    try {
      // Update existing apartment title
      await axios.put(`https://api.biznetusa.com/api/update-searchbyapartment/${editId}`, formDataToSubmit);
      setShowAlert({ visible: true, type: 'success', message: 'Apartment title updated successfully' });
      setTitle('');
      setEditId(null);
      setShowModal(false); // Close modal after update
      fetchApartmentList(); // Refresh apartment list after update
    } catch (error) {
      console.error(error);
      setShowAlert({ visible: true, type: 'danger', message: 'Failed to update data' });
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://api.biznetusa.com/api/deletesearchbyapartment/${id}`);
      setShowAlert({ visible: true, type: 'success', message: 'Apartment title deleted successfully' });
      fetchApartmentList(); // Refresh apartment list after deletion
    } catch (error) {
      console.error(error);
      setShowAlert({ visible: true, type: 'danger', message: 'Failed to delete apartment title' });
    }
  };

  // Filtered apartments based on search term
  const filteredApartments = apartmentList.filter((apartment) =>
    apartment.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Container className="mt-5">
      {/* Center the Add New Apartment Title Section */}
      <Row className="justify-content-center">
        <Col md={8} lg={6} className="text-center mb-4">
          <h2 className="display-4">Add New Apartment Title</h2>
        </Col>
      </Row>

      {/* Form for Adding New Apartment Title */}
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          {showAlert.visible && (
            <Alert variant={showAlert.type} onClose={() => setShowAlert({ visible: false })} dismissible>
              {showAlert.message}
            </Alert>
          )}

          <Form onSubmit={handleSubmit} className="shadow p-4 rounded bg-white">
            <Form.Group controlId="formTitle">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter apartment title"
                value={title}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="mt-3 w-100">
              Submit New Title
            </Button>
          </Form>
        </Col>
      </Row>

      {/* Search and Table Section */}
      <Row className="justify-content-between mt-5">
        <Col>
          <h3 className="text-center">Existing Apartment Titles</h3>
        </Col>
        <Col md={4} className="text-right">
          <Form.Control
            type="text"
            placeholder="Search by title"
            value={searchTerm}
            onChange={handleSearchChange}
            className="shadow-sm"
          />
        </Col>
      </Row>

      {/* Table to display filtered apartments */}
      <Table striped bordered hover responsive="md" className="mt-3 shadow-sm bg-white">
        <thead className="thead-light">
          <tr>
            <th>#</th>
            <th>Title</th>
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredApartments.map((apartment, index) => (
            <tr key={apartment.id}>
              <td className="align-middle text-center">{index + 1}</td>
              <td className="align-middle text-left">{apartment.title}</td>
              <td className="align-middle text-center">
                <Button
                  variant="info"
                  className="mr-2 btn-sm"
                  onClick={() => handleEdit(apartment)}
                >
                  Edit
                </Button>
                <Button
                  variant="danger"
                  className="btn-sm"
                  onClick={() => handleDelete(apartment.id)}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal for updating the apartment title */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Apartment Title</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleUpdate}>
            <Form.Group controlId="formTitle">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter new apartment title"
                value={title}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="mt-3 w-100">
              Update Title
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default ApartmentByCity;
